// assets
import { IconDashboard, IconUser, IconBuildingStore, IconBrandSlack, IconUpload, IconTransform } from '@tabler/icons';

// constant
const icons = {
    IconDashboard,
    IconUser,
    IconBuildingStore,
    IconBrandSlack,
    IconUpload,
    IconTransform
};

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const qpDashboard = {
    id: 'qpAdminMainMenu',
    type: 'group',
    children: [
        {
            id: 'dashboard-home',
            title: 'Dashboard',
            type: 'item',
            url: 'qp-admin/home',
            breadcrumbs: true,
            icon: icons.IconDashboard
        },
        {
            id: 'service-provider-management',
            title: 'Service Provider Management',
            type: 'item',
            url: 'qp-admin/manage-service-provider',
            breadcrumbs: true,
            icon: icons.IconBrandSlack
        },
        {
            id: 'client-management',
            title: 'Client Management',
            type: 'item',
            url: 'qp-admin/manage-client',
            breadcrumbs: true,
            icon: icons.IconUser
        },
        {
            id: 'vendor-management',
            title: 'Vendor Management',
            type: 'item',
            url: 'qp-admin/manage-vendor',
            breadcrumbs: true,
            icon: icons.IconBuildingStore
        },
        {
            id: 'upload-transactions',
            title: 'Upload Transactions',
            type: 'item',
            url: 'qp-admin/upload-transactions',
            breadcrumbs: true,
            icon: icons.IconUpload
        },
        {
            id: 'money-flow',
            title: 'Money Flow',
            type: 'item',
            url: 'qp-admin/money-flow',
            breadcrumbs: true,
            icon: icons.IconTransform
        }
    ]
};

export default qpDashboard;
